<vb-loading-spinner [block]="true" [iconClass]="'vb-icon vb-icon-camera'" [msg]="msg" [msgDisplayBelowSpinner]="true" [size]="'large'" [state]="state">
</vb-loading-spinner>